<ng-template #dropdown>
  <ng-content></ng-content>
</ng-template>
